<style>
.ivu-modal-footer {
  border: none;
}

.ivu-select-multiple {
  height: 32px;
}

.ivu-select-selection {
  z-index: 100;
}
</style>
<template>
  <div>
    <page-head :title="title" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn"></page-head>
    <div class="content">
      <div class="toptab">
        <div class="toptableft">
          <span :class="tapidnex == 0 ? 'activetap' : 'nomaltap'" @click="tabclick(0)">小一</span>
          <span :class="tapidnex == 1 ? 'activetap' : 'nomaltap'" @click="tabclick(1)">初一</span>
          <!-- <span :class="tapidnex == 2 ? 'activetap' : 'nomaltap'" @click="tabclick(2)">五升六</span> -->
          <!-- <span :class="tapidnex==9?'activetap':'nomaltap'"  @click="tabclick(9)">民办</span> -->
          <!-- <span :class="tapidnex==8?'activetap':'nomaltap'"  @click="tabclick(8)">地丘管理</span> -->
        </div>
      </div>

      <div class="search" v-if="tapidnex < 3">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="4">
              <form-item label="学生姓名" prop="studentName">
                <Input v-model="query.studentName" clearable placeholder="请输入学生姓名" />
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="学生身份证号" prop="studentIdCardNum">
                <Input v-model="query.studentIdCardNum" clearable placeholder="请输入证件号码" />
              </form-item>
            </i-col>
            <!-- <i-col span="4">
              <form-item label="户籍" prop="studentRegister">
                <Select v-model="query.studentRegister" clearable>
                  <Option v-for="item in registerlist" :key="item.index" :value="item.index" :label="item.type">
                  </Option>
                </Select>
              </form-item>
            </i-col> -->

            <i-col span="4">
              <form-item label="居住情况" prop="studentType">
                <Select v-model="query.studentType" clearable>
                  <Option v-for="item in typeList" :key="item.index" :value="item.index" :label="item.type"></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="房产类型" prop="estateCertType">
                <Select v-model="query.estateCertType" clearable>
                  <Option v-for="item in estateCertTypelist" :key="item.index" :value="item.index" :label="item.type">
                  </Option>
                </Select>
              </form-item>
            </i-col>

            <i-col span="4">
              <form-item label="地丘号" prop="landNum">
                <Input v-model="query.landNum" clearable placeholder="请输入地丘号" />
              </form-item>
            </i-col>

            <i-col span="4" v-show="showopen">
              <form-item label="分配学校" prop="schoolName">
                <Select v-model="query.schoolName" clearable>
                  <Option v-for="item in schoollist" :key="item.index" :value="item.schoolName"
                    :label="item.schoolName"></Option>
                </Select>
              </form-item>
            </i-col>

            <i-col span="4" v-show="showopen">
              <form-item label="审核状态" prop="registrationStatus">
                <Select v-model="query.registrationStatus" clearable>
                  <Option v-for="item in useList" :key="item.index" :value="item.index" :label="item.type"></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen">
              <form-item label="租赁年限" prop="leaseYears">
                <Select v-model="query.leaseYears" clearable>
                  <Option v-for="item in leaseYearslist" :key="item.index" :value="item.index" :label="item.type">
                  </Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen">
              <form-item label="小区名称" prop="residentialName">
                <Input v-model="query.residentialName" clearable placeholder="请输入小区名称" />
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen && tapidnex == 2">
              <form-item label="就读学校" prop="graduatedSchool">
                <Input v-model="query.graduatedSchool" clearable placeholder="请输入就读学校" />
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen && tapidnex == 1">
              <form-item label="毕业学校" prop="primarySchool">
                <Input v-model="query.primarySchool" clearable placeholder="请输入毕业学校" />
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen">
              <form-item label="区域名称" prop="county">
                <Select v-model="query.county" clearable>
                  <Option v-for="item in schoolRegionlist" :key="item.index" :value="item.type" :label="item.type">
                  </Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen">
              <form-item label="校验状态" prop="bigDataProcess">
                <Select v-model="query.bigDataProcess" clearable multiple>
                  <Option v-for="item in processList" :key="item.index" :value="item.index" :label="item.type"></Option>
                </Select>
              </form-item>
            </i-col>
            <!-- <i-col span="4" v-show="showopen">
              <form-item label="是否有地丘号" prop="haveLandNum">
                <Select v-model="query.haveLandNum" clearable>
                  <Option
                    v-for="item in haveLandNumlist"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col> -->

            <i-col span="4" v-show="showopen">
              <form-item label="是否提交" prop="isCommit">
                <Select v-model="query.isCommit" clearable>
                  <Option v-for="item in isCommittype" :key="item.index" :value="item.index" :label="item.type">
                  </Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen">
              <form-item label="分配情况" prop="assignType">
                <Select v-model="query.assignType" clearable>
                  <Option v-for="item in assignTypelist" :key="item.index" :value="item.index" :label="item.type">
                  </Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen">
              <form-item label="是否修改地丘号" prop="remarkValue">
                <Select v-model="query.remarkValue" clearable>
                  <Option v-for="item in remarkValuelist" :key="item.index" :value="item.index" :label="item.type">
                  </Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen">
              <form-item label="原地丘号" prop="beforeLandNum">
                <Input v-model="query.beforeLandNum" clearable placeholder="请输入原地丘号" />
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen">
              <form-item label="入学时间" prop="admissionDate">
                <DatePicker type="daterange" split-panels placeholder="请选择日期" v-model="admissionDate"
                  style="width: 100%;"></DatePicker>
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen && tapidnex == 1">
              <form-item label="是否有学籍" prop="havaGraduationSix">
                <Select v-model="query.havaGraduationSix" clearable>
                  <Option v-for="item in havaGraduationSixtype" :key="item.index" :value="item.index"
                    :label="item.type"></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4" v-show="showopen">
              <form-item label="是否为城区户口" prop="domicile">
                <Select v-model="query.domicile" clearable>
                  <Option v-for="item in havaGraduationSixtypes" :key="item.index" :value="item.index"
                    :label="item.type"></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="审核备注" prop="firstCheckRemark">
                <Input v-model="query.firstCheckRemark" clearable placeholder="请输入审核备注" />
              </form-item>
            </i-col>
          </row>
        </i-form>
        <div class="opens" v-show="!showopen" @click="open"><span>展开</span><span
            class="openicon iconfont icon--icon_arrow_up"></span></div>
        <div class="opens" v-show="showopen" @click="open"><span>收起</span><span
            class="iconfont icon--icon_arrow_up"></span></div>
      </div>

      <div class="table-data" v-if="tapidnex < 3">
        <div class="bottomtable">
          <i-table :columns="tableHeader" :border="true" :loading="isLoading" :data="tableData" stripe ref="table"
            height="540" @on-selection-change="handleSelect">
            <template slot-scope="{ row, index }" slot="action">
              <span @click="handleClickDetail(row, 'detail')" class="action">[详情]</span>
              <Poptip transfer confirm title="确认删除?" placement="left" @on-ok="handleClickDetail(row, 'del')">
                <span class="action">[删除]</span>
              </Poptip>
              <!-- <span class="action" @click="handleClickDetail(row, 'audit')">[审核]</span> -->
            </template>

          </i-table>
        </div>

        <div class="page">
          <page :total="total" :current="pageNum" :page-size="pageSize" :page-size-opts="pagesizeopts"
            @on-change="pageChange" show-total show-sizer @on-page-size-change="onpagesizechange" />
        </div>
      </div>

      <Modal v-model="delmodel" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>删除确认</span>
        </p>
        <div style="text-align:center">
          <p>是否确认删除所勾选学生信息？</p>
        </div>
        <div slot="footer">
          <Button type="info" @click="hidedelmodel">取消</Button>
          <Button type="success" @click="handleAllDelete">删除</Button>
        </div>
      </Modal>

      <Modal v-model="modal2" title="批量审核" height="700" draggable>
        <p style="color:#FF0000;margin-bottom: 10px;">仅全部模块校验成功的学生,才可以进行批量审核。</p>
        <i-form ref="search" :model="formItems">
          <row>
            <i-col span="24">
              <form-item label="审核结果" prop="selects">
                <Select v-model="formItems.selects" clearable @on-change="selectschange">
                  <Option v-for="item in selectslist" :key="item.index" :value="item.index" :label="item.type"></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="24">
              <form-item label="批量审核备注" prop="tips">
                <Input v-model="formItems.tips" clearable placeholder="请输入审核结果原因" />
              </form-item>
            </i-col>
          </row>
        </i-form>
        <div slot="footer">
          <Button type="info" @click="canceldochecklist">取消</Button>
          <Button v-if="tapidnex != 2" type="success" @click="domoreaudits">批量审核</Button>
          <Button v-if="tapidnex == 2" type="success" @click="domoreaudits">
            <template v-if="auditPermissions == 1">批量审核(初审)</template>
            <template v-else-if="auditPermissions == 2">批量审核(复审)</template>
            <template v-else-if="auditPermissions == 3">批量审核(交叉复审)</template>
          </Button>
        </div>
      </Modal>

      <Modal v-model="modal3" title="分配学校" height="500" draggable>
        <i-form ref="search" :model="shoolquery" style="height:200px;">
          <row>
            <i-col span="24">
              <form-item prop="schoolId">
                <Select v-model="shoolquery.schoolId" clearable>
                  <Option v-for="item in schoollist1" :key="item.index" :value="item.schoolId" :label="item.schoolName">
                  </Option>
                </Select>
              </form-item>
            </i-col>
          </row>
        </i-form>
        <div slot="footer">
          <Button type="info" @click="cancelschoolinfo">取消</Button>
          <Button type="success" @click="doschoolinfo">确认分配</Button>
        </div>
      </Modal>

    </div>
  </div>
</template>

<script>
import miment from "miment";
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import api from "../../../api/index";
const {
  selectAllCommitStudent,//学生列表信息
  selectSignUpCommitInfo,
  selectSchoolInfo,
  insertNewStudentSchool,
  getadminVerifyList,
  deleteAllInfoByStudentId,//伪删除
  educationPermissionCheck,//查询是否教育局
  selectSchoolNameAndId,
  exportCsvVerify,
  assignSchool,
  selectDeptList,
  selectAllEducationInfo,
  exportExcelByMap,
  judgeCheckAuth,
  selectSchoolNameAndIdByUid,
  pseudoDeleteAllInfoList
} = api;
const TYPEMAP = {
  0: { studentType: "城区购房人员子女" },
  1: { studentType: "城区租房居住人员子女" },
  2: { studentType: "享受教育优惠政策人员子女" },
  3: { studentType: "城区无购房无租房人员子女" },
};
const STATUSMAPs = {
  0: { firstCheckStatus: "未审核" },
  1: { firstCheckStatus: "审核成功" },
  2: { firstCheckStatus: "审核退回" },
  3: { firstCheckStatus: "复审成功" },
  4: { firstCheckStatus: "审核退回" },
  5: { firstCheckStatus: "重新上报" },
  6: { firstCheckStatus: "未审核" }
}
const STATUSMAP = {
  0: { firstCheckStatus: "未审核" },
  1: { firstCheckStatus: "初审成功" },
  2: { firstCheckStatus: "初审失败" },
  3: { firstCheckStatus: "复审成功" },
  4: { firstCheckStatus: "复审退回" },
  5: { firstCheckStatus: "重新上报" },
  6: { firstCheckStatus: "未审核" }
}
const STATUSMAP1 = {
  0: { secondCheckStatus: "未审核" },
  1: { secondCheckStatus: "初审成功" },
  2: { secondCheckStatus: "初审失败" },
  3: { secondCheckStatus: "复审成功" },
  4: { secondCheckStatus: "复审退回" },
  5: { secondCheckStatus: "重新上报" },
  6: { secondCheckStatus: "未审核" }
}
const CHECKRESULT = {
  0: { otherVerify: "校验成功", },
  1: { otherVerify: "未上传材料", },
  2: { otherVerify: "已上传材料", },
  3: { otherVerify: "材料上传不完整", },
  4: { otherVerify: "材料初审成功", },
  5: { otherVerify: "材料复审成功", },
};
const CHECKRESULT1 = {
  0: { accountBookVerify: "校验成功", },
  1: { accountBookVerify: "未上传材料", },
  2: { accountBookVerify: "已上传材料", },
  3: { accountBookVerify: "材料上传不完整", },
  4: { accountBookVerify: "材料初审成功", },
  5: { accountBookVerify: "材料复审成功", },
};
const CHECKRESULT2 = {
  0: { deedVerify: "校验成功", },
  1: { deedVerify: "未上传材料", },
  2: { deedVerify: "已上传材料", },
  3: { deedVerify: "材料上传不完整", },
  4: { deedVerify: "材料初审成功", },
  5: { deedVerify: "材料复审成功", },
};
const CHECKRESULT3 = {
  0: { idcardOneVerify: "校验成功", },
  1: { idcardOneVerify: "未上传材料", },
  2: { idcardOneVerify: "已上传材料", },
  3: { idcardOneVerify: "材料上传不完整", },
  4: { idcardOneVerify: "材料初审成功", },
  5: { idcardOneVerify: "材料复审成功", },
};
const CHECKRESULT4 = {
  0: { idcardTwoVerify: "校验成功", },
  1: { idcardTwoVerify: "未上传材料", },
  2: { idcardTwoVerify: "已上传材料", },
  3: { idcardTwoVerify: "材料上传不完整", },
  4: { idcardTwoVerify: "材料初审成功", },
  5: { idcardTwoVerify: "材料复审成功", },
};
const CHECKRESULT5 = {
  0: { workVerify: "校验成功", },
  1: { workVerify: "未上传材料", },
  2: { workVerify: "已上传材料", },
  3: { workVerify: "材料上传不完整", },
  4: { workVerify: "材料初审成功", },
  5: { workVerify: "材料复审成功", },
};
const CHECKRESULT6 = {
  0: { permitVerify: "校验成功", },
  1: { permitVerify: "未上传材料", },
  2: { permitVerify: "已上传材料", },
  3: { permitVerify: "材料上传不完整", },
  4: { permitVerify: "材料初审成功", },
  5: { permitVerify: "材料复审成功", },
};
const leaseYears = {
  0: { leaseYears: "不满1年", },
  1: { leaseYears: "满1年", },
  2: { leaseYears: "满2年", },
  3: { leaseYears: "满3年", },
  4: { leaseYears: "满4年", },
  5: { leaseYears: "满5年", },
};
const assignStatusList = {
  0: { assignStatus: "未分配" },
  1: { assignStatus: "初次分配" },
  2: { assignStatus: "再次分配" },
}
export default {
  name: "newstudent",
  components: {
    pageHead,
    PreviewImg,
  },

  data() {
    return {
      showopen: false,
      delmodel: false,
      auditPermissions: 2,
      schoollist: [],
      schoollist1: [],
      iseducation: false,
      modal2: false,
      modal3: false,
      modal1: false,
      modal4: false,
      tapidnex: 1,
      checkMsg: "",
      checkedId: "",
      showCheckMsg: false,
      modalTitle: "",
      showPreview: {
        show: 0,
        list: [],
      },
      havaGraduationSixtype: [
        { index: 1, type: "具有" },
        { index: 2, type: "不具有" },
      ],
      havaGraduationSixtypes: [
        { index: 1, type: "是" },
        { index: 2, type: "否" },
      ],
      remarkValuelist: [
        { index: "408", type: "用户修改了地丘号" },
        { index: "410", type: "地丘号信息为手动填写" },
        { index: "notUpdateLandNum", type: "未修改地丘号" },
        { index: "401", type: "购房未查询到" },
        { index: "431", type: "租赁未查询到" },
      ],
      registerlist: [
        { index: 1, type: "市城区" },
        { index: 2, type: "非市城区" },
      ],
      assignTypelist: [
        { index: 0, type: "未分配" },
        { index: 1, type: "初次分配" },
        { index: 2, type: "再次分配" },
      ],
      schoolRegionlist: [
        { index: 0, type: "市直" },
        { index: 1, type: "油田" },
        { index: 2, type: "开发区" },
        { index: 3, type: "华龙区" },
        { index: 4, type: "示范区" },
        { index: 5, type: "未匹配" }
      ],
      haveLandNumlist: [
        { index: 0, type: "否" },
        { index: 1, type: "是" },
      ],
      assignSchoollist: [
        { index: 0, type: "否" },
        { index: 1, type: "是" }
      ],
      isCommittype: [
        { index: 0, type: "未提交" },
        { index: 1, type: "提交" }
      ],
      leaseYearslist: [
        { index: 0, type: "不满1年" },
        { index: 1, type: "满1年" },
        { index: 2, type: "满2年" },
        { index: 3, type: "满3年" },
        { index: 4, type: "满4年" },
        { index: 5, type: "满5年" }
      ],
      typeList: [
        { index: 0, type: "购房人员子女" },
        { index: 1, type: "租房居住人员子女" },
        { index: 2, type: "享受教育优惠政策人员子女" },
        { index: 3, type: "无购房无租房人员子女" }
      ],
      estateCertTypelist: [
        { index: 1, type: "不动产证（房产证）" },
        { index: 2, type: "购房合同(预告登记)" },
        { index: 3, type: "自建房" },
        { index: 4, type: "祖辈房产" }
      ],
      useList: [
        { index: 0, type: "初审未审核" },
        { index: 1, type: "初审成功" },
        { index: 2, type: "初审失败" },
        { index: 3, type: "复审成功" },
        { index: 4, type: "复审退回" },
        { index: 5, type: "重新上报" },
        { index: 6, type: "复审未审核" }
      ],
      selectslist: [
        { index: 0, type: "通过" },
        { index: 1, type: "不通过" }
      ],
      processList: [
        { index: 0, type: "基本信息校验成功" },
        { index: 1, type: "户籍信息校验成功" },
        { index: 2, type: "监护人1信息校验成功" },
        { index: 3, type: "监护人2信息校验成功" },
        { index: 4, type: "居住信息校验成功" },
        { index: 5, type: "居住证信息校验成功" },
        { index: 6, type: "工作信息校验成功" },
        { index: 7, type: "基本信息校验不成功" },
        { index: 8, type: "户籍信息校验不成功" },
        { index: 9, type: "监护人1信息校验不成功" },
        { index: 10, type: "监护人2信息校验不成功" },
        { index: 11, type: "居住信息校验不成功" },
        { index: 12, type: "居住证信息校验不成功" },
        { index: 13, type: "工作信息校验不成功" }
      ],
      admissionDate: ['2022-01-01', miment().add(1, 'DD').format()],
      query: {
        studentIdCardNum: "",
        bigDataProcess: '',
        county: "",
        graduatedSchool: "",
        primarySchool: "",
        residentialName: "",
        estateCertType: "",
        studentRegister: "",
        studentName: "",
        haveLandNum: "",
        landNum: "",
        schoolName: "",
        studentType: '',
        registrationStatus: '',
        assignSchool: "",
        leaseYears: '',
        isCommit: '',
        assignType: '',
        remarkValue: "",
        beforeLandNum: "",
        schoolType: 1,
        domicile: '',
        havaGraduationSix: null,
        firstCheckRemark:'',
        beginTime: "2022-01-01",
        endTime: miment().add(1, 'DD').format()
      },

      formItems: {
        selects: '',
        notice: '',
        tips: '',
      },
      shoolquery: {
        schoolId: ''
      },
      estateUnitNO: "",
      estateUnitNOList: [],
      status: "",
      info: {},
      time: "",
      isLoading: false,
      isBtbLoading: false,
      pageNum: 1,
      pageSize: 20,
      pagesizeopts: [20, 40, 60, 80, 100],
      total: 0,
      title: "新生入学",
      btnList: [{ name: "查询", type: "search" },
      { name: "重置", type: "refsh" },
      { name: "导出csv", type: "export" },
      { name: "批量审核", type: "moreaudits" },
      { name: "分配学校", type: "distribution" },
      { name: "批量删除", type: "del" }],
      tableHeader: [],
      tableData: [],
      selectedList: [],
      selectedListid: [],
      selectedListidlist: [],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  watch: {
    admissionDate(newVal, oldVal) {
      this.query.beginTime = miment(newVal[0]).format()
      this.query.endTime = miment(newVal[1]).add(1, 'DD').format()
    }
  },
  methods: {
    open() {
      this.showopen = !this.showopen
    },
    hidedelmodel() {
      this.delmodel = false
    },
    selectschange(e) {
      console.log(e)
      if (e === 0) {
        this.formItems.tips = "通过"
      } else {
        this.formItems.tips = ""
      }
    },
    onpagesizechange(e) {
      console.log(e)
      this.pageSize = e
      this.pageNum = 1;
      this.getLandTransferList(this.tapidnex + 1)
    },
    async getassignSchool() {
      let url = assignSchool + this.shoolquery.schoolId
      console.log(url)
      let data = this.selectedListid
      console.log(data)
      let res = await this.$post(url, data);
      if (res.isSucceed) {
        this.$Message.info("分配学校成功");
        this.modal3 = false;
        this.getLandTransferList(this.tapidnex + 1)
      }
    },
    doschoolinfo() {
      console.log(this.shoolquery)
      console.log(this.selectedListid)
      if (this.shoolquery.schoolId) {
        this.getassignSchool()
      } else {
        this.$Message.info("请选择分配学校");
      }
    },
    cancelschoolinfo() {
      this.shoolquery = {
        schoolName: ''
      }
      this.modal3 = false;
    },
    tabclick(idnex) {
      if (idnex < 3) {
        this.tapidnex = idnex;
        if (this.tapidnex == 0) {
          this.getLandTransferList(1)
          this.auditPermissions = 1
          this.useList = [
            { index: 0, type: "未审核" },
            { index: 1, type: "审核成功" },
            { index: 2, type: "审核退回" },
            { index: 5, type: "重新上报" }
          ]
          this.btnList = [{ name: "查询", type: "search" },
          { name: "重置", type: "refsh" },
          { name: "导出csv", type: "export" },
          { name: "批量审核", type: "moreaudits" },
          { name: "分配学校", type: "distribution" },
          { name: "批量删除", type: "del" }]
        } else if (this.tapidnex == 1) {
          this.getLandTransferList(2)
          this.auditPermissions = 1
          this.useList = [
            { index: 0, type: "未审核" },
            { index: 1, type: "审核成功" },
            { index: 2, type: "审核退回" },
            { index: 5, type: "重新上报" }
          ]
          this.btnList = [{ name: "查询", type: "search" },
          { name: "重置", type: "refsh" },
          { name: "导出csv", type: "export" },
          { name: "批量审核", type: "moreaudits" },
          { name: "分配学校", type: "distribution" },
          { name: "批量删除", type: "del" }]
        } else if (this.tapidnex == 2) {
          this.getLandTransferList(3)
          this.judgeCheckAuth()
          this.useList = [
            { index: 0, type: "初审未审核" },
            { index: 1, type: "初审成功" },
            { index: 2, type: "初审失败" },
            { index: 3, type: "复审成功" },
            { index: 4, type: "复审退回" },
            { index: 5, type: "重新上报" },
            { index: 6, type: "复审未审核" }
          ]
        }
        this.getselectSchoolNameAndId()
        this.getselectSchoolNameAndIdByUid()
      } else if (idnex == 8) {
        this.$router.push({
          name: "landnum",
          query: {}
        });
      } else if (idnex == 9) {
        this.$router.push({
          name: "index1",
          query: {}
        });
      }

    },
    dorefresh() {
      this.selectedList = []
      this.selectedListid = []
      this.selectedListidlist = []
      this.pageNum = 1;
      this.query = {
        studentIdCardNum: "",
        bigDataProcess: '',
        county: "",
        graduatedSchool: "",
        primarySchool: "",
        residentialName: "",
        estateCertType: "",
        studentRegister: "",
        studentName: "",
        haveLandNum: "",
        landNum: "",
        schoolName: "",
        studentType: '',
        registrationStatus: '',
        assignSchool: "",
        leaseYears: '',
        isCommit: '',
        assignType: '',
        domicile: '',
        firstCheckRemark:'',
        remarkValue: "",
        beforeLandNum: "",
        schoolType: 1,
        havaGraduationSix: null
      }
      this.getLandTransferList(this.tapidnex + 1)
    },
    async handleAllDelete() {
      console.log(this.selectedListid)
      if (this.selectedListid.length == 0) {
        this.$Message.info("请至少选择一项数据");
        return;
      } else {
        if (this.iseducation) {
          if (localStorage["uid"]) {
            let url = pseudoDeleteAllInfoList + localStorage["uid"]
            let data = this.selectedListid
            let res = await this.$post(url, data);
            if (res.isSucceed) {
              this.delmodel = false
              this.$Message.success("删除成功");
              this.getLandTransferList(this.tapidnex + 1)
            }
          } else {
            this.$Message.info("uid过期，请重新登录");
          }
        } else {
          this.$Message.info("您无此权限");
        }
      }

    },
    handleBtn(type) {
      if (type == "search") {
        this.pageNum = 1;
        this.getLandTransferList(this.tapidnex + 1)
      }
      else if (type == "del") {
        if (this.selectedListid.length == 0) {
          this.$Message.info("请至少选择一项数据");
          return;
        } else {
          this.delmodel = true
        }
      }
      else if (type == "refsh") {
        this.dorefresh()
      }
      else if (type == "moreaudits") {//批量审核
        if (this.selectedList.length == 0) {
          this.$Message.info("请至少选择一项数据");
          return;
        } else {
          this.formItems = {
            selects: '',
            notice: '',
            tips: '',
          }
          this.modal2 = true
        }
      }
      else if (type == "distribution") {//分配学校
        if (this.iseducation) {
          console.log(this.selectedList)
          if (this.selectedList.length == 0) {
            this.$Message.info("请至少选择一项数据");
            return;
          } else {
            this.shoolquery = {
              schoolId: ''
            }
            this.modal3 = true
          }
        } else {
          this.$Message.info("您无此权限");
        }

      }
      else if (type == "export") {//导出
        this.doexport()
      }
    },
    async doexport() {
      let type = this.tapidnex + 1
      let urls = exportCsvVerify + type + "/" + localStorage["uid"]
      let ress = await this.$post(urls, {});
      console.log(ress)
      if (ress.isSucceed) {
        let url = exportExcelByMap + type + "/" + localStorage["uid"] + "/1";
        let newquerys = {};
        newquerys = Object.assign(newquerys, this.query)
        newquerys.haveLandNum = newquerys.haveLandNum + ''
        newquerys.assignSchool = newquerys.assignSchool + ''
        newquerys.leaseYears = newquerys.leaseYears + ''
        newquerys.remarkValue = newquerys.remarkValue + ''
        newquerys.beforeLandNum = newquerys.beforeLandNum + ''
        if (this.query.haveLandNum === '' || this.query.haveLandNum === undefined || this.query.haveLandNum === "undefined") { newquerys.haveLandNum = "2" }
        if (this.query.assignSchool === '' || this.query.assignSchool === undefined || this.query.assignSchool === "undefined") { newquerys.assignSchool = "2" }
        console.log(newquerys)
        if (newquerys.studentName == undefined || newquerys.studentName == "undefined") {
          newquerys.studentName = ''
        }
        if (newquerys.assignType === undefined || newquerys.assignType == "undefined") {
          newquerys.assignType = ''
        }
        if (newquerys.assignType === undefined || newquerys.assignType == "undefined") {
          newquerys.assignType = ''
        }
        if (newquerys.isCommit === undefined || newquerys.isCommit == "undefined") {
          newquerys.isCommit = ''
        }
        if (newquerys.studentType == undefined || newquerys.studentType == "undefined") {
          newquerys.studentType = ''
        }
        if (newquerys.haveLandNum == undefined || newquerys.haveLandNum == "undefined") {
          newquerys.haveLandNum = ''
        }
        if (newquerys.studentRegister === undefined || newquerys.studentRegister == "undefined") {
          newquerys.studentRegister = ''
        }
        if (newquerys.studentIdCardNum === undefined || newquerys.studentIdCardNum == "undefined") {
          newquerys.studentIdCardNum = ''
        }
        if (newquerys.bigDataProcess === undefined || newquerys.bigDataProcess == "undefined") {
          newquerys.bigDataProcess = ''
        }
        if (newquerys.county === undefined || newquerys.county == "undefined") {
          newquerys.county = ''
        }
        if (newquerys.graduatedSchool === undefined || newquerys.graduatedSchool == "undefined") {
          newquerys.graduatedSchool = ''
        }
        if (newquerys.primarySchool === undefined || newquerys.primarySchool == "undefined") {
          newquerys.primarySchool = ''
        }
        if (newquerys.residentialName === undefined || newquerys.residentialName == "undefined") {
          newquerys.residentialName = ''
        }
        if (newquerys.estateCertType === undefined || newquerys.estateCertType == "undefined") {
          newquerys.estateCertType = ''
        }
        if (newquerys.landNum === undefined || newquerys.landNum == "undefined") {
          newquerys.landNum = ''
        }
        if (newquerys.schoolName === undefined || newquerys.schoolName == "undefined") {
          newquerys.schoolName = ''
        }
        if (newquerys.remarkValue === undefined || newquerys.remarkValue == "undefined") {
          newquerys.remarkValue = ''
        }
        if (newquerys.beforeLandNum === undefined || newquerys.beforeLandNum == "undefined") {
          newquerys.beforeLandNum = ''
        }
        if (newquerys.havaGraduationSix === undefined || newquerys.havaGraduationSix == "undefined") {
          newquerys.havaGraduationSix = ''
        }
        if (!newquerys.havaGraduationSix) {
          newquerys.havaGraduationSix = ''
        }

        if (newquerys.leaseYears === undefined || newquerys.leaseYears == "undefined") {
          newquerys.leaseYears = ''
        }
        if (newquerys.registrationStatus === undefined || newquerys.registrationStatus == "undefined") {
          newquerys.registrationStatus = ''
        }
        url = url + "?bigDataProcess=[" + newquerys.bigDataProcess + "]"
          + "&county=" + newquerys.county
          + "&studentIdCardNum=" + newquerys.studentIdCardNum
          + "&graduatedSchool=" + newquerys.graduatedSchool
          + "&primarySchool=" + newquerys.primarySchool
          + "&residentialName=" + newquerys.residentialName
          + "&estateCertType=" + newquerys.estateCertType
          + "&studentRegister=" + newquerys.studentRegister
          + "&studentName=" + newquerys.studentName
          + "&haveLandNum=" + newquerys.haveLandNum
          + "&landNum=" + newquerys.landNum
          + "&schoolName=" + newquerys.schoolName
          + "&studentType=" + newquerys.studentType
          + "&registrationStatus=" + newquerys.registrationStatus
          + "&assignSchool=" + newquerys.assignSchool
          + "&isCommit=" + newquerys.isCommit
          + "&assignType=" + newquerys.assignType
          + "&leaseYears=" + newquerys.leaseYears
          + "&schoolType=" + newquerys.schoolType
          + "&remarkValue=" + newquerys.remarkValue
          + "&beforeLandNum=" + newquerys.beforeLandNum
          + "&havaGraduationSix=" + newquerys.havaGraduationSix
          + "&beginTime=" + newquerys.beginTime
          + "&endTime=" + newquerys.endTime
          + "&token=" + window.sessionStorage.getItem("token")
        console.log(url)
        window.open(url)
      }
    },
    handleSelect(selection) {
      this.selectedList = [];
      this.selectedListid = [];
      this.selectedListidlist = []
      console.log(selection);
      selection.forEach((item) => {
        this.selectedList.push(item.studentName);
        this.selectedListid.push(item.studentId);
        this.selectedListidlist.push({ newStudentId: item.studentId });
      });
    },
    canceldochecklist() {
      this.formItems = {
        selects: '',
        notice: '',
        tips: ''
      }
      this.modal2 = false;
    },
    async domoreaudits(e) {
      let that = this
      console.log(this.formItems.selects)
      if (this.formItems.selects) {

      } else {
        if (this.formItems.selects !== 0) {
          this.$Message.info("请选择审核结果");
          return;
        }
      }

      if (!this.formItems.tips) {
        this.$Message.info("请输入批量审核备注");
        return;
      }

      console.log(this.selectedListidlist)
      let data = this.selectedListidlist
      let checkStatus = 0
      if (this.auditPermissions == 1) {
        checkStatus = Number(this.formItems.selects) + 1
      } else if (this.auditPermissions == 2) {
        checkStatus = Number(this.formItems.selects) + 3
      }
      let obj = {
        "checkUid": localStorage["uid"],
        "checkRemark": that.formItems.tips,
        "checkStatus": checkStatus
      }
      for (let i = 0; i < data.length; i++) {
        data[i] = Object.assign(data[i], obj);
      }
      console.log(data)
      let url = getadminVerifyList + "/" + this.auditPermissions
      let res = await that.$post(url, data);
      console.log(res)
      if (res.isSucceed) {
        that.$Message.success("审核完成");
        that.formItems = {
          selects: '',
          tips: '',
        }
        this.modal2 = false;
        that.pageNum = 1;
        that.getLandTransferList(this.tapidnex + 1);
      }

    },
    cancelModal() { },

    async handleDelete(id) {
      if (localStorage["uid"]) {
        let url = deleteAllInfoByStudentId + id + "/" + localStorage["uid"]
        console.log(url)
        console.log(id)
        let res = await this.$post(url, {});
        if (res.isSucceed) {
          this.$Message.success("删除成功");
          this.getLandTransferList(this.tapidnex + 1)
        }
      } else {
        this.$Message.info("uid过期，请重新登录");
      }
    },
    handleClickDetail(item, type) {
      console.log(item, type);
      if (type == "detail") {
        localStorage.setItem("querydata", JSON.stringify(this.query))
        localStorage.setItem("tapidnex", this.tapidnex)
        localStorage.setItem("pageNum", this.pageNum)
        localStorage.setItem("pageSize", this.pageSize)
        this.$router.push({
          name: "newStudentsdetail",
          query: {
            studentId: item.studentId,
            schooltype: this.tapidnex + 1,
            iseducation: this.iseducation,
            auditPermissions: this.auditPermissions,
            publictype: 1
          }
        });
      } else if (type == "del") {
        this.handleDelete(item.studentId);
      } else if (type == "audit") {

      }
    },
    pageChange(val) {
      this.pageNum = val;
      this.getLandTransferList(this.tapidnex + 1);
    },
    // 获取初审复审权限
    async judgeCheckAuth() {
      let type = this.tapidnex + 1
      let url = judgeCheckAuth + localStorage["uid"] + "/" + type
      let res = await this.$post(url, {});
      console.log(res)
      if (res.isSucceed) {
        this.auditPermissions = res.rows[0]
        if (this.auditPermissions == 0) {
          this.btnList = [{ name: "查询", type: "search" },
          { name: "重置", type: "refsh" },
          { name: "导出csv", type: "export" },
          { name: "分配学校", type: "distribution" },
          { name: "批量删除", type: "del" }
          ]
        } else if (this.auditPermissions == 1) {
          this.btnList = [{ name: "查询", type: "search" },
          { name: "重置", type: "refsh" },
          { name: "导出csv", type: "export" },
          { name: "批量审核(初审)", type: "moreaudits" },
          { name: "分配学校", type: "distribution" },
          { name: "批量删除", type: "del" }
          ]
        } else if (this.auditPermissions == 2) {
          this.btnList = [{ name: "查询", type: "search" },
          { name: "重置", type: "refsh" },
          { name: "导出csv", type: "export" },
          { name: "批量审核(复审)", type: "moreaudits" },
          { name: "分配学校", type: "distribution" },
          { name: "批量删除", type: "del" }]

        } else if (this.auditPermissions == 3) {
          this.btnList = [{ name: "查询", type: "search" },
          { name: "重置", type: "refsh" },
          { name: "导出csv", type: "export" },
          { name: "批量审核(交叉复审)", type: "moreaudits" },
          { name: "分配学校", type: "distribution" },
          { name: "批量删除", type: "del" }]

        }
      }
    },
    async getselectSchoolNameAndIdByUid() {
      let type = this.tapidnex + 1
      let url = selectSchoolNameAndIdByUid + type + "/" + localStorage["uid"] + "/1"
      let res = await this.$get(url, {});
      console.log(res)
      if (res.isSucceed) {
        if (res.rows) {
          for (let i = 0; i < res.rows.length; i++) {
            res.rows[i].index = i
          }
          this.schoollist1 = res.rows
        }
      }
    },
    async getselectSchoolNameAndId() {
      let type = this.tapidnex + 1
      let url = selectSchoolNameAndId + "/" + type + "/1";
      let res = await this.$get(url, {});
      console.log(res)
      if (res.isSucceed) {
        if (res.rows) {
          for (let i = 0; i < res.rows.length; i++) {
            res.rows[i].index = i
          }
          this.schoollist = res.rows
        }
      }
    },
    async getLandTransferList(type) {
      console.log(type)
      if (type == 1) {
        this.tableHeader = [
          { type: "selection", width: 70, align: "center", fixed: 'left' },
          { title: "学生姓名", key: "studentName", width: 100, fixed: 'left', align: "center" },
          { title: "学生身份证号", key: "studentIdcardNum", width: 190, align: "center" },
          { title: "分配学校", key: "schoolName", width: 180, align: "center" },
          { title: "分配情况", key: "assignStatus", width: 100, align: "center" },
          { title: "居住情况", key: "studentType", width: 180, align: "center" },
          { title: "是否市城区户口", key: "domicile", width: 140, align: "center" },
          { title: "产权证类别", key: "estateCertType", width: 180, align: "center" },
          { title: "地丘号", key: "landNum", width: 80, align: "center" },
          { title: "原地丘号", key: "beforeLandNum", width: 100, align: "center" },
          { title: "是否提交审核", key: "istijiao", width: 140, align: "center" },
          { title: "审核状态", key: "firstCheckStatus", width: 100, align: "center" },
          { title: "审核备注", key: "firstCheckRemark", width: 180, align: "center" },
          { title: "租赁年限", key: "leaseYears", width: 100, align: "center" },
          { title: "小区名称", key: "residentialName", width: 180, align: "center" },
          { title: "区域名称", key: "county", width: 100, align: "center" },
          { title: "基础信息", key: "otherVerify", width: 130, align: "center" },
          { title: "户籍", key: "accountBookVerify", width: 130, align: "center" },
          { title: "监护人1", key: "idcardOneVerify", width: 130, align: "center" },
          { title: "监护人2", key: "idcardTwoVerify", width: 130, align: "center" },
          { title: "居住信息", key: "deedVerify", width: 130, align: "center" },
          { title: "居住证", key: "permitVerify", width: 130, align: "center" },
          { title: "工作信息", key: "workVerify", width: 130, align: "center" },
          { title: "操作", slot: "action", width: 140, fixed: "right", align: "center" },
        ]
      } else if (type == 2) {
        this.tableHeader = [
          { type: "selection", width: 70, align: "center", fixed: 'left' },
          { title: "学生姓名", key: "studentName", width: 100, fixed: 'left', align: "center" },
          { title: "学生身份证号", key: "studentIdcardNum", width: 190, align: "center" },
          { title: "毕业学校", key: "primarySchool", width: 180, align: "center" },
          { title: "分配学校", key: "schoolName", width: 180, align: "center" },
          { title: "分配情况", key: "assignStatus", width: 100, align: "center" },
          { title: "居住情况", key: "studentType", width: 180, align: "center" },
          { title: "是否市城区户口", key: "domicile", width: 140, align: "center" },
          { title: "是否有学籍", key: "havaGraduationSix", width: 140, align: "center" },
          { title: "产权证类别", key: "estateCertType", width: 180, align: "center" },
          { title: "地丘号", key: "landNum", width: 80, align: "center" },
          { title: "原地丘号", key: "beforeLandNum", width: 100, align: "center" },
          { title: "是否提交审核", key: "istijiao", width: 140, align: "center" },
          { title: "审核状态", key: "firstCheckStatus", width: 100, align: "center" },
          { title: "审核备注", key: "firstCheckRemark", width: 180, align: "center" },
          { title: "租赁年限", key: "leaseYears", width: 100, align: "center" },
          { title: "小区名称", key: "residentialName", width: 180, align: "center" },
          { title: "区域名称", key: "county", width: 100, align: "center" },
          { title: "基础信息", key: "otherVerify", width: 130, align: "center" },
          { title: "户籍", key: "accountBookVerify", width: 130, align: "center" },
          { title: "监护人1", key: "idcardOneVerify", width: 130, align: "center" },
          { title: "监护人2", key: "idcardTwoVerify", width: 130, align: "center" },
          { title: "居住信息", key: "deedVerify", width: 130, align: "center" },
          { title: "居住证", key: "permitVerify", width: 130, align: "center" },
          { title: "工作信息", key: "workVerify", width: 130, align: "center" },
          { title: "操作", slot: "action", width: 140, fixed: "right", align: "center" },
        ]
      } else if (type == 3) {
        this.tableHeader = [
          { type: "selection", width: 70, align: "center", fixed: 'left' },
          { title: "学生姓名", key: "studentName", fixed: 'left', width: 100, align: "center" },
          { title: "学生身份证号", key: "studentIdcardNum", width: 190, align: "center" },
          { title: "就读学校", key: "graduatedSchool", width: 180, align: "center" },
          { title: "分配学校", key: "schoolName", width: 180, align: "center" },
          { title: "分配情况", key: "assignStatus", width: 100, align: "center" },
          { title: "居住情况", key: "studentType", width: 180, align: "center" },
          { title: "是否市城区户口", key: "domicile", width: 140, align: "center" },
          { title: "产权证类别", key: "estateCertType", width: 180, align: "center" },
          { title: "地丘号", key: "landNum", width: 80, align: "center" },
          { title: "原地丘号", key: "beforeLandNum", width: 100, align: "center" },
          { title: "是否提交审核", key: "istijiao", width: 140, align: "center" },
          { title: "初审状态", key: "firstCheckStatus", width: 100, align: "center" },
          { title: "复审状态", key: "secondCheckStatus", width: 100, align: "center" },
          { title: "租赁年限", key: "leaseYears", width: 100, align: "center" },
          { title: "小区名称", key: "residentialName", width: 180, align: "center" },
          { title: "区域名称", key: "county", width: 100, align: "center" },
          { title: "基础信息", key: "otherVerify", width: 130, align: "center" },
          { title: "户籍", key: "accountBookVerify", width: 130, align: "center" },
          { title: "监护人1", key: "idcardOneVerify", width: 130, align: "center" },
          { title: "监护人2", key: "idcardTwoVerify", width: 130, align: "center" },
          { title: "居住信息", key: "deedVerify", width: 130, align: "center" },
          { title: "操作", slot: "action", width: 140, fixed: "right", align: "center" },
        ]
      }
      this.isLoading = true;
      this.selectedList = []
      this.selectedListid = []
      this.selectedListidlist = []
      let url = selectAllCommitStudent + type + "/" + localStorage["uid"]
      console.log(this.query);
      let newquerys = {};
      newquerys = Object.assign(newquerys, this.query)
      newquerys.haveLandNum = newquerys.haveLandNum + ''
      newquerys.assignSchool = newquerys.assignSchool + ''
      newquerys.leaseYears = newquerys.leaseYears + ''
      newquerys.remarkValue = newquerys.remarkValue + ''
      newquerys.beforeLandNum = newquerys.beforeLandNum + ''
      if (this.query.haveLandNum === '' || this.query.haveLandNum === undefined || this.query.haveLandNum === "undefined") { newquerys.haveLandNum = "2" }
      if (this.query.assignSchool === '' || this.query.assignSchool === undefined || this.query.assignSchool === "undefined") { newquerys.assignSchool = "2" }
      console.log(newquerys)
      if (newquerys.studentName == undefined || newquerys.studentName == "undefined") {
        newquerys.studentName = ''
      }
      if (newquerys.assignType === undefined || newquerys.assignType == "undefined") {
        newquerys.assignType = ''
      }
      if (newquerys.isCommit === undefined || newquerys.isCommit == "undefined") {
        newquerys.isCommit = ''
      }
      if (newquerys.studentType == undefined || newquerys.studentType == "undefined") {
        newquerys.studentType = ''
      }
      if (newquerys.haveLandNum == undefined || newquerys.haveLandNum == "undefined") {
        newquerys.haveLandNum = ''
      }
      if (newquerys.studentRegister === undefined || newquerys.studentRegister == "undefined") {
        newquerys.studentRegister = ''
      }
      if (newquerys.studentIdCardNum === undefined || newquerys.studentIdCardNum == "undefined") {
        newquerys.studentIdCardNum = ''
      }
      if (newquerys.bigDataProcess === undefined || newquerys.bigDataProcess == "undefined") {
        newquerys.bigDataProcess = ''
      }
      if (newquerys.county === undefined || newquerys.county == "undefined") {
        newquerys.county = ''
      }
      if (newquerys.graduatedSchool === undefined || newquerys.graduatedSchool == "undefined") {
        newquerys.graduatedSchool = ''
      }
      if (newquerys.primarySchool === undefined || newquerys.primarySchool == "undefined") {
        newquerys.primarySchool = ''
      }

      if (newquerys.residentialName === undefined || newquerys.residentialName == "undefined") {
        newquerys.residentialName = ''
      }
      if (newquerys.estateCertType === undefined || newquerys.estateCertType == "undefined") {
        newquerys.estateCertType = ''
      }
      if (newquerys.landNum === undefined || newquerys.landNum == "undefined") {
        newquerys.landNum = ''
      }
      if (newquerys.schoolName === undefined || newquerys.schoolName == "undefined") {
        newquerys.schoolName = ''
      }
      if (newquerys.leaseYears === undefined || newquerys.leaseYears == "undefined") {
        newquerys.leaseYears = ''
      }
      if (newquerys.remarkValue === undefined || newquerys.remarkValue == "undefined") {
        newquerys.remarkValue = ''
      }
      if (newquerys.beforeLandNum === undefined || newquerys.beforeLandNum == "undefined") {
        newquerys.beforeLandNum = ''
      }
      if (newquerys.havaGraduationSix === undefined || newquerys.havaGraduationSix == "undefined") {
        newquerys.havaGraduationSix = null
      }

      if (newquerys.registrationStatus === undefined || newquerys.registrationStatus == "undefined") {
        newquerys.registrationStatus = ''
      }
      try {
        let res = await this.$post(url, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...newquerys,
        });
        let list = []
        if (type == 3) {
          list = res.rows.map((item) => ({
            ...item,
            domicile: item.domicile == '1' ? '是' : '否',
            istijiao: item.process == '12' ? '是' : '否',
            ...assignStatusList[item.assignStatus != null ? +item.assignStatus : null],
            ...TYPEMAP[item.studentType != null ? +item.studentType : null],
            ...STATUSMAP[item.firstCheckStatus != null ? +item.firstCheckStatus : 0],
            ...STATUSMAP1[item.secondCheckStatus != null ? +item.secondCheckStatus : 6],
            ...CHECKRESULT[item.otherVerify != null ? +item.otherVerify : null],
            ...CHECKRESULT1[item.accountBookVerify != null ? +item.accountBookVerify : null],
            ...CHECKRESULT2[item.deedVerify != null ? +item.deedVerify : null],
            ...CHECKRESULT4[item.idcardTwoVerify != null ? +item.idcardTwoVerify : null],
            ...CHECKRESULT3[item.idcardOneVerify != null ? +item.idcardOneVerify : null],
            ...CHECKRESULT5[item.workVerify != null ? +item.workVerify : null],
            ...CHECKRESULT6[item.permitVerify != null ? +item.permitVerify : null],
            ...leaseYears[item.leaseYears != null ? +item.leaseYears : null],
          }));
        } else {
          list = res.rows.map((item) => ({
            ...item,
            domicile: item.domicile == '1' ? '是' : '否',
            istijiao: item.process == '12' ? '是' : '否',
            havaGraduationSix: item.havaGraduationSix == 1 ? '具有' : '不具有',
            ...assignStatusList[item.assignStatus != null ? +item.assignStatus : null],
            ...TYPEMAP[item.studentType != null ? +item.studentType : null],
            ...STATUSMAPs[item.firstCheckStatus != null ? +item.firstCheckStatus : 0],
            ...STATUSMAP1[item.secondCheckStatus != null ? +item.secondCheckStatus : 6],
            ...CHECKRESULT[item.otherVerify != null ? +item.otherVerify : null],
            ...CHECKRESULT1[item.accountBookVerify != null ? +item.accountBookVerify : null],
            ...CHECKRESULT2[item.deedVerify != null ? +item.deedVerify : null],
            ...CHECKRESULT4[item.idcardTwoVerify != null ? +item.idcardTwoVerify : null],
            ...CHECKRESULT3[item.idcardOneVerify != null ? +item.idcardOneVerify : null],
            ...CHECKRESULT5[item.workVerify != null ? +item.workVerify : null],
            ...CHECKRESULT6[item.permitVerify != null ? +item.permitVerify : null],
            ...leaseYears[item.leaseYears != null ? +item.leaseYears : null],
          }));
        }

        console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    },
    async geteducationPermissionCheck() {
      if (localStorage["uid"]) {
        let url = educationPermissionCheck + localStorage["uid"]
        let res = await this.$post(url, {});
        console.log(res)
        if (res.isSucceed && res.code == 1) {
          this.iseducation = true
        } else {
          this.iseducation = false
        }
      } else {
        this.$Message.info("uid过期，请重新登录");
      }
    },
  },

  created() {
    this.modal1 = false;
    if (localStorage["querydata"]) {
      this.query = JSON.parse(localStorage["querydata"])
      localStorage.removeItem("querydata")
    }
    if (localStorage["tapidnex"]) {
      this.tapidnex = Number(localStorage["tapidnex"])
      localStorage.removeItem("tapidnex")
    }
    if (localStorage["pageNum"]) {
      this.pageNum = localStorage["pageNum"]
      this.pageSize = localStorage["pageSize"]
      localStorage.removeItem("pageNum")
      localStorage.removeItem("pageSize")
    }
    console.log(this.tapidnex)
    if (this.tapidnex == 0) {
      this.getLandTransferList(1)
      this.auditPermissions = 1
      this.useList = [
        { index: 0, type: "未审核" },
        { index: 1, type: "审核成功" },
        { index: 2, type: "审核退回" },
        { index: 5, type: "重新上报" }
      ]
    } else if (this.tapidnex == 1) {
      this.getLandTransferList(2)
      this.auditPermissions = 1
      this.useList = [
        { index: 0, type: "未审核" },
        { index: 1, type: "审核成功" },
        { index: 2, type: "审核退回" },
        { index: 5, type: "重新上报" }
      ]
    } else if (this.tapidnex == 2) {
      this.getLandTransferList(3)
      this.judgeCheckAuth()
      this.useList = [
        { index: 0, type: "初审未审核" },
        { index: 1, type: "初审成功" },
        { index: 2, type: "初审失败" },
        { index: 3, type: "复审成功" },
        { index: 4, type: "复审退回" },
        { index: 5, type: "重新上报" },
        { index: 6, type: "复审未审核" }
      ]
    }
    this.geteducationPermissionCheck()
    this.getselectSchoolNameAndId()
    this.getselectSchoolNameAndIdByUid()
  },
  mounted() { },
};
</script>

<style  scoped lang="less">
.content {
  margin: 0 20px 20px 20px;
}

.toptab {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  border-bottom: solid 1px #EEEEEE;
}

.toptableft {
  width: 100%;
  display: flex;
  display: -webkit-flex;
}

.toptableft span {
  width: 86px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-size: 16px;
}

.toptableft span:nth-child(4) {
  width: 136px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-size: 16px;
}

.bottombtn {
  width: 150px;
  text-align: center;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #FFFFFF;
  border-radius: 6px;
  background: #0097FF;
}

.activetap {
  background: #FF7B44;
  color: #FFFFFF;
  border-radius: 6px 6px 0 0;
}

.nomaltap {
  background: #FFFFFF;
  color: #666666;
  border-radius: 6px 6px 0 0;
  border: solid 1px #EEEEEE;
}

.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}

.time {
  width: 100%;
}

.bottomtable {
  width: 100%;
  padding: 20px;
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  // padding: 20px;
  min-height: calc(100vh - 450px);

  .page {
    width: 100%;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
  }

  .success {
    color: #ff7b44;
  }

  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
}

.statistics {
  padding: 10px 0;
  text-align: right;
}

.estateTitle {
  color: #ff7b44;
  font-weight: bold;
}

.estateNO {
  color: #ff7b44;
  font-weight: 400;
  background: #ffefe9;
  margin: 0 15px 10px 0;
}

.topformbox {
  width: 100%;
  background: #F8F8F8;
  height: 80px;
  border-radius: 4px 4px 0px 0px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}

.topformbox .ivu-form {
  width: 100%;
  height: 80px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.topformbox .ivu-form .ivu-form-item {
  margin: 0;
  width: 360px;
}

.topformbox .ivu-form .ivu-form-item:nth-child(1) {
  margin-left: 21px;
}

.topformboxright {
  height: 80px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.topformboxright span:nth-child(1) {
  width: 92px;
  height: 28px;
  background: #FF7943;
  border-radius: 4px;
  text-align: center;
  line-height: 28px;
  font-size: 14px;
  color: #FFFFFF;
  margin-right: 20px;
}

.topformboxright span:nth-child(2) {
  width: 120px;
  height: 28px;
  background: #F9FAFA;
  border: 1px solid #DEDEDE;
  border-radius: 4px;
  text-align: center;
  line-height: 28px;
  font-size: 14px;
  color: #4B4B4B;
  margin-right: 20px;
}

.schoolbox {
  width: 100%;
}

.opens {
  margin: 0 auto;
  height: 30px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.opens span:nth-child(2) {
  margin-left: 40px;
  color: #666666;
}

.openicon {
  transform: rotate(180deg);
}
</style>
